import { BlockProps } from "../../containers/Block";

export default function Waitlist({ block }: BlockProps) {
  return <div>Waitlist - {block.blockId}</div>;
}
